import React, { useState } from "react";
import { injectIntl } from "react-intl";
import TypeaheadBox from "../Form/TypeaheadBox";
import intlShape from "../../shapes/intlShape";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";
import { withUser } from "../../wrappers";
import { Column, Row } from "../Grid";

type Props = {
  api: apiShape;
  intl: intlShape;
  name: string;
  notifier: notifierShape;
  values?: {
    usergroup?: $TSFixMe;
  };
  excludables?: $TSFixMe[];
};

export function UserGroupTypeahead(props: Props) {
  const [userGroups, setuserGroups] = useState();
  const [fetching, setFetching] = useState();

  const { api, notifier, intl, values, name, excludables } = props;

  const loadOptions = async (searchText = "") => {
    try {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
      setFetching(true);
      const response = await api.get("/usergroups", {
        name: `${searchText}*`,
      });
      const allGroups = response.usergroups.map((userGroup: $TSFixMe) => ({
        id: userGroup.id,
        name: userGroup.name,
      }));
      let validSelection = allGroups;
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      if (excludables?.length > 0) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        const idsToExclude = excludables.map((a) => a.id);
        validSelection = allGroups.filter(
          (record: $TSFixMe) => !idsToExclude.includes(record.id),
        );
      }
      setuserGroups(validSelection);
    } catch (error) {
      notifier.showError(api.translateError(error));
    } finally {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
      setFetching(false);
    }
  };

  React.useEffect(() => {
    loadOptions();
  }, [JSON.stringify(excludables)]);

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const selectedGroup = values[name];

  return (
    <Row>
      <Column>
        <TypeaheadBox
          {...props}
          // @ts-expect-error TS(2322) FIXME: Type '{ info: string | null; options: undefined; f... Remove this comment to see the full error message
          info={
            selectedGroup?.new
              ? intl.formatMessage({ id: "usergroup_typeahead.new_info" })
              : null
          }
          options={userGroups}
          fetching={fetching}
          loadOptions={loadOptions}
        />
      </Column>
    </Row>
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type '{ (props: Readonly<Omit<Readonly... Remove this comment to see the full error message
export default injectIntl(withUser(withNotifier(withApi(UserGroupTypeahead))));
